import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import WebDevelopment from "./pages/WebDevelopment";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import AIMLSolutions from "./pages/AIMLSolutions";
import EcommerceSolutions from "./pages/EcommerceSolutions";
import EnterpriseSolutions from "./pages/EnterpriseSolutions";
import QATesting from "./pages/QATesting";
import UIUXDesign from "./pages/UIUXDesign";
import CloudDevOps from "./pages/CloudDevOps";
import APIIntegration from "./pages/APIIntegration";
import HostingPage from "./pages/HostingPage";

import CRMSolution from "./pages/CRMSolution";
import ERPSolution from "./pages/ERPSolution";
import HRMSolution from "./pages/HRMSolution";
import LMSSolution from "./pages/LMSSolution";
import POSSolution from "./pages/POSSolution";
import CMSSolution from "./pages/CMSSolution";
import HospitalManagement from "./pages/HospitalManagement";
import InventoryManagement from "./pages/InventoryManagement";
import AIChatbot from "./pages/AIChatbot";
import BusinessDashboard from "./pages/BusinessDashboard";
import PrintingSolution from "./pages/PrintingSolution";

import Healthcare from "./pages/Healthcare";
import RealEstate from "./pages/RealEstate";
import Education from "./pages/Education";
import TravelHospitality from "./pages/TravelHospitality";
import Manufacturing from "./pages/Manufacturing";
import MediaEntertainment from "./pages/MediaEntertainment";
import FinanceInsurance from "./pages/FinanceInsurance";
import Logistics from "./pages/Logistics";
import EnterpriseIndustry from "./pages/EnterpriseIndustry";

import TechnologiesPage from "./pages/TechnologiesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import AboutUs from "./pages/AboutUs";
import CareersPage from "./pages/CareersPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import InsightsPage from "./pages/InsightsPage";
import AdminLeads from "./pages/AdminLeads";

import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import AIChatWidget from "./components/AIChatWidget";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<PortfolioPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/technologies" element={<TechnologiesPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Services */}
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/ecommerce-solutions" element={<EcommerceSolutions />} />
          <Route path="/ai-ml-solutions" element={<AIMLSolutions />} />
          <Route path="/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/cloud-devops" element={<CloudDevOps />} />
          <Route path="/hosting" element={<HostingPage />} />
          <Route path="/api-integration" element={<APIIntegration />} />
          <Route path="/qa-testing" element={<QATesting />} />
          <Route path="/enterprise-solutions" element={<EnterpriseSolutions />} />

          {/* Solutions */}
          <Route path="/erp-solution" element={<ERPSolution />} />
          <Route path="/crm-solution" element={<CRMSolution />} />
          <Route path="/hrm-solution" element={<HRMSolution />} />
          <Route path="/hospital-management" element={<HospitalManagement />} />
          <Route path="/lms-solution" element={<LMSSolution />} />
          <Route path="/pos-solution" element={<POSSolution />} />
          <Route path="/cms-solution" element={<CMSSolution />} />
          <Route path="/inventory-management" element={<InventoryManagement />} />
          <Route path="/ai-chatbot" element={<AIChatbot />} />
          <Route path="/business-dashboard" element={<BusinessDashboard />} />
          <Route path="/printing-solution" element={<PrintingSolution />} />

          {/* Industries */}
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/digital-healthcare-solutions" element={<Healthcare />} />
          <Route path="/finance-insurance" element={<FinanceInsurance />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/education" element={<LMSSolution />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/travel-hospitality" element={<TravelHospitality />} />
          <Route path="/media-entertainment" element={<MediaEntertainment />} />
          <Route path="/enterprise-industry" element={<EnterpriseSolutions />} />

          {/* Support Pages */}
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/contactus" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

          {/* Secure Admin Lead Console */}
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="/admin/leads" element={<AdminLeads />} />

          {/* Wildcard Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <WhatsAppWidget />
        <AIChatWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
